<template>
  <button
    v-if="canPledge"
    :disabled="shouldDisableControls || totalQuantity === 0 || isPledgeLoading"
    @click="handlePledge"
    class="btn btn-primary items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <span v-if="!isPledgeLoading" class="icon pledge w-5 h-5"></span>
    <span v-if="isPledgeLoading" class="loading loading-spinner loading-sm"></span>
    {{ isPledgeLoading ? $t('campaigns.show.pledging') : $t('campaigns.show.pledge') }}
  </button>
</template>

<script>
import { computed, inject } from 'vue'

export default {
  name: 'PledgeButton',
  setup() {
    return {
      canPledge: inject('canPledge', computed(() => false)),
      totalQuantity: inject('totalQuantity'),
      isPledgeLoading: inject('isPledgeLoading'),
      handlePledge: inject('handlePledge'),
      shouldDisableControls: inject('shouldDisableControls', computed(() => false))
    }
  }
}
</script>
